import React from 'react';
import classnames from 'classnames';

import { RelatedSDG } from './RelatedSDG';

import { InnerBlocks } from '../assets/components';

export { name } from './related-sdgs.json';
export { RelatedSDGs as renderer };

export function RelatedSDGs({ data, ...rest }) {
  const { attributes, innerBlocks } = data;

  const { blockClass, prefix, className } = attributes;

  const blockClasses = classnames(blockClass, className, prefix);

  return (
    <>
      <InnerBlocks as={RelatedSDG} className={blockClasses} blocks={innerBlocks} />
    </>
  );
}
